import styled from 'styled-components';
import { Button as MuiButton } from '@mui/material';
export var Button = styled(MuiButton).withConfig({
  displayName: "style__Button",
  componentId: "sc-1d23bsc-0"
})(["color:", " !important;"], function (_ref) {
  var theme = _ref.theme;
  return theme.white;
});